import React from 'react';

const SIZE_CLASSES = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-10 h-10 border-[3px]',
};

export function LoadingSpinner({ size = 'md', className = '' }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <span
        className={`${SIZE_CLASSES[size]} inline-block rounded-full border-border-soft border-t-accent animate-spin`}
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}

export default LoadingSpinner;
